/**
 * Determines file extension from MIME type
 */
function getFileExtension(mimeType: string | undefined): string {
  switch (true) {
    case mimeType?.includes('mp4'):
      return 'mp4';
    case mimeType?.includes('ogg'):
      return 'ogg';
    case mimeType?.includes('webm'):
      return 'webm';
    default:
      return 'webm';
  }
}

/**
 * Creates a File object from recorded audio blob
 * Falls back to Blob if File constructor is not available
 */
export function createRecordedAudioFile(
  blob: Blob,
  mimeType: string | undefined
): File | Blob {
  if (typeof File === 'undefined') return blob;

  const extension = getFileExtension(mimeType);
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  const filename = `recorded-audio-${timestamp}.${extension}`;

  try {
    return new File([blob], filename, {
      type: mimeType || 'audio/webm',
    });
  } catch {
    return blob;
  }
}
